import { useCallback, useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useActiveEditTarget } from '~/hooks/target/useActiveEditTarget';
import { bulkRoiSelectionActiveState } from '~/state/atoms/structureSet/roiAtoms';
import { operationPanelState } from '~/state/atoms/toolsAtoms';
import UnifiedOperationPanel from './UnifiedOperationPanel';

export default function OperationsPanelHandler() {
    const [panelState, setPanelState] = useRecoilState(operationPanelState);
    const { roiId: selectedROI } = useActiveEditTarget();
    const isBulkSelectionActive = useRecoilValue(bulkRoiSelectionActiveState);

    // Auto-close margin/ring panel when no ROI is selected
    useEffect(() => {
        if (
            (selectedROI === null || isBulkSelectionActive) &&
            (panelState.type === 'margin' || panelState.type === 'ring')
        ) {
            setPanelState({ type: 'closed' });
        }
    }, [selectedROI, isBulkSelectionActive, panelState.type, setPanelState]);

    const handleClose = useCallback(() => {
        setPanelState({ type: 'closed' });
    }, [setPanelState]);

    if (panelState.type === 'closed') {
        return null;
    }

    return (
        <UnifiedOperationPanel panelState={panelState} onClose={handleClose} />
    );
}
